import { defineStore } from 'pinia'
import { ref } from 'vue'

// 统一使用亮色主题的极简状态管理
export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(false)

  const applyLightTheme = () => {
    const root = document.documentElement
    isDark.value = false
    root.classList.add('light')
    root.classList.remove('dark')
  }

  const initTheme = () => {
    applyLightTheme()
  }

  // 兼容旧调用，仍然强制使用亮色
  const toggleTheme = () => {
    applyLightTheme()
  }

  return {
    isDark,
    initTheme,
    toggleTheme
  }
})
